export default [
    //交互跑动
    {
        path: '/paodong/paodong',
        name: '/paodong/paodong',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/paodong/paodong.vue'),
    },
]
